import {UI} from "../../../../../../stem-core/src/ui/UIBase.js";
import {BasePanelPage} from "../../../../PanelPage";
import {BlinkInput, BlinkInputStyle} from "../../../../../ui/Input";
import {Messages} from "../../../../../Messages";
import {Flow} from "../../../../initializeFlows";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {TextArea} from "../../../../../../stem-core/src/ui/input/Input";
import {styleRuleInherit} from "../../../../../../stem-core/src/decorators/Style";
import {Router} from "../../../../../../stem-core/src/ui/Router";

class BlinkTextAreaStyle extends BlinkInputStyle {
    @styleRuleInherit
    inputContainer = {
        height: 106,
    };

    @styleRuleInherit
    input = {
        padding: "12px 5px",
        overflow: "auto",
        resize: "none",
    };
}

export class GiftSubscriptionPlansPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.giftDetails,
        };
    }

    render() {
        const {styleSheet} = this;
        const {giftBeneficiaryEmailAddress, name, message} = Flow.giftSubscription;

        return [
            <BlinkInput ref="emailInput" inputAttributes={{type: "email"}} testId="giftEmailInput"
                        label={Messages.giftEmail} onChange={() => this.redraw()}
                        initialValue={giftBeneficiaryEmailAddress}/>,
            <BlinkInput ref="nameInput" testId="giftNameInput" label={Messages.giftName}
                        onChange={() => this.redraw()} initialValue={name}/>,
            <BlinkInput ref="messageInput" testId="giftMessageInput" label={Messages.giftMessage}
                        styleSheet={BlinkTextAreaStyle} onChange={() => this.redraw()} initialValue={message}
                        InputClass={TextArea}/>,
            <MerchantButton className={styleSheet.actionButton} disabled={this.isButtonDisabled()} onClick={() => this.continue()}>
                {Messages.continue}
            </MerchantButton>,
            <div className={styleSheet.backButton} onClick={() => Router.back()}>
                {Messages.back}
            </div>
        ];
    }

    async continue() {
        Flow.giftSubscription.giftBeneficiaryEmailAddress = this.emailInput.getValue();
        Flow.giftSubscription.name = this.nameInput.getValue();
        Flow.giftSubscription.message = this.messageInput.getValue();
        await Flow.giftSubscription.onGiftDetailsProvided();
    }

    isButtonDisabled() {
        return !(this.emailInput?.getValue());
    }
}
